import { Navigate, Route, Routes } from 'react-router-dom';

import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import Instructions from './pages/Instructions';
import Landing from './pages/Landing';
import Payments from './pages/Payments';
import Purchase from './pages/Purchase';
import Referral from './pages/Referral';
import Support from './pages/Support';

function RequireAuth({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem('vpnsaler_access');
  if (!token) return <Navigate to="/auth" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/purchase"
        element={
          <RequireAuth>
            <Purchase />
          </RequireAuth>
        }
      />
      <Route
        path="/instructions"
        element={
          <RequireAuth>
            <Instructions />
          </RequireAuth>
        }
      />
      <Route
        path="/referral"
        element={
          <RequireAuth>
            <Referral />
          </RequireAuth>
        }
      />
      <Route
        path="/payments"
        element={
          <RequireAuth>
            <Payments />
          </RequireAuth>
        }
      />
      <Route
        path="/support"
        element={
          <RequireAuth>
            <Support />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
